<script lang="ts">
  import { entries, byCategory } from "../lib/content";
  import { categoryById } from "../lib/categories";
  import { favourites } from "../lib/stores";
  import SopCard from "../lib/components/SopCard.svelte";
  import CategoryPills from "../lib/components/CategoryPills.svelte";
  import type { SopCategory } from "../lib/types";

  export let params: { cat: string } = { cat: "" };

  $: catId = params.cat;
  $: isFavourites = catId === "favourites";
  $: category = isFavourites ? null : categoryById(catId);

  $: sops = isFavourites
    ? $entries.filter((s) => $favourites.has(s.slug))
    : category
      ? byCategory($entries, catId as SopCategory)
      : [];

  $: title = isFavourites ? "Favourites" : category?.label ?? "Unknown";
  $: subtitle = isFavourites
    ? "SOPs you've starred"
    : category?.description ?? "This category has no SOPs yet.";

  $: validForFilter = (isFavourites ? "favourites" : (catId as SopCategory | "all")) as
    | SopCategory
    | "all"
    | "favourites";
</script>

<div class="flex flex-col gap-6">
  <div class="flex flex-col gap-2">
    <h1 class="text-3xl font-semibold tracking-tight">{title}</h1>
    <p class="text-text-muted">{subtitle}</p>
  </div>

  <CategoryPills active={validForFilter} />

  {#if sops.length === 0}
    <div class="panel p-8 text-center text-text-muted">
      {#if isFavourites}
        Star an SOP from any list to keep it here for quick access.
      {:else}
        No SOPs in this category yet.
      {/if}
    </div>
  {:else}
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {#each sops as sop (sop.slug)}
        <SopCard {sop} />
      {/each}
    </div>
  {/if}
</div>
